import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import type { ListGeneratorVisualInspectionsResponse } from '@/api/generated/HCA'

export const generatorVisualInspectionsQueryKey = (componentSid: string) =>
    ['generators', componentSid, 'visual-inspection'] as const

export async function fetchGeneratorVisualInspectionList(
    componentSid: string,
    signal?: AbortSignal,
): Promise<ListGeneratorVisualInspectionsResponse | undefined> {
    const {
        data: { result },
    } = await hcaClientFactory.componentStatusApi.listVisualInspectionsByGeneratorSid(
        componentSid,
        0,
        0,
        undefined,
        undefined,
        undefined,
        { signal },
    )
    return result
}
